<section class="manufacturer-orders-page">
  <!-- <div class="custom-login background-image manufacturer-page-background"></div> -->
  <div class="custom-login background-image"></div>

  <div class="manufacturer-orders-shell">
    <h1 class="manufacturer-page-user">
      {{ user?.ac_first_name }} {{ user?.ac_last_name }} -
      <!--
        Fix v2.14.6 (PM feedback): mostra codice_fornitore quando il
        BE lo restituisce, altrimenti fallback su account_id. Alcuni
        record legacy in DB hanno codice_fornitore = null ma
        account_id valorizzato — così l'header non appare vuoto/troncato
        con solo "Nome Cognome - " e trailing dash pendente.
      -->
      {{ user?.codice_fornitore || user?.account_id }}
    </h1>

    <div class="manufacturer-orders-header">
      <img
        class="manufacturer-header-logo"
        src="assets/icons/logo-diakonix-black.png"
        alt="Connecta"
      />
      <!-- (click)="openLegend()" -->

      <h1 class="manufacturer-page-title">{{ currentSectionLabel }}</h1>

      <div class="manufacturer-profile-wrapper">
        <ion-button
          fill="clear"
          id="profile-popover-trigger"
          class="manufacturer-profile-btn"
          (click)="openProfile($event)"
        >
          <ion-icon slot="icon-only" name="person-circle-outline"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="manufacturer-filter-row">
      <form class="manufacturer-search" role="search">
        <label for="manufacturer-search" class="manufacturer-search__label">
          <i class="bx bx-layer"></i>
          <span>Cerca un nuovo ordine:</span>
        </label>

        <div class="manufacturer-search__controls">
          <div class="manufacturer-search__input">
            <i class="bx bx-search manufacturer-search__leading-icon"></i>

            @if (filterTerm) {
              <i
                class="bx bxs-x-circle bx-md clearSearchIcon manufacturer-clear-search"
                (click)="clearSearch()"
              ></i>
            }

            <input
              [(ngModel)]="filterTerm"
              id="manufacturer-search"
              name="search"
              type="search"
              placeholder="N° conto lavoro livith 0000.."
              style="position: relative; right: 10px"
            />
          </div>

          <button
            type="button"
            class="gamma-orders-search__button"
            aria-label="Cerca ordine"
            [disabled]="!filterTerm.trim()"
            (click)="addOrder(filterTerm)"
          >
            <i class="bx bx-search"></i>
            <span>PROCESSA</span>
          </button>

          <!-- <button
            type="button"
            aria-label="Cerca ordine"

          >
            <i class="bx bx-search bx-sm"></i>
            <span>CERCA</span>
          </button> -->
        </div>
      </form>
    </div>

    <div class="manufacturer-search-divider"></div>

    <p class="manufacturer-total-orders">
      {{ totalOrdersLabel }}:
      <strong>{{ totalOrdersToCheck | async }}</strong>
    </p>

    <div
      class="manufacturer-tabs"
      role="tablist"
      aria-label="Viste ordini produttore"
    >
      @for (tab of tabs; track tab.key) {
        <button
          type="button"
          class="manufacturer-tab"
          [ngClass]="tab.background"
          [class.is-active]="isCurrentTab(tab.key)"
          (click)="setActiveTab(tab.key)"
        >
          <i [class]="tab.icon"></i>
          <span>{{ tab.label }}</span>
        </button>
      }
    </div>
    @switch (activeTab) {
      @case ("history") {
        <app-history [accountId]="accountId"></app-history>
      }
      @case ("partial") {
        <app-partial
          [accountId]="accountId"
          (orderProcessed)="setActiveTab('inProgress')"
        ></app-partial>
      }
      <!--@case ("nonConforming") {
        <app-non-conform></app-non-conform>
      }-->
      @default {
        <app-processing [accountId]="accountId"></app-processing>
      }
    }
  </div>
  <div class="footer">©{{ currentYear }} | Connecta</div>
</section>
@if (closeSrv.isPassOpn()) {
  <app-profile [passOpen]="closeSrv.isPassOpn()" [account_id]="modifyBtn">
  </app-profile>
}
<!-- @if (isGammaOrdersOpen) {
  <app-gamma-orders
    [orderNumber]="filterTerm"
    (closed)="closeGammaOrdersPopup()"
  ></app-gamma-orders>
} -->
